import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { catchError, map, of, tap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  // Otherwise check session (for page refresh case)
  return authenticationService.checkSession().pipe(
    map((isValid) => {
      if (isValid) {
        return true;
      } else {
        return router.createUrlTree(['/auth', 'login']);
      }
    }),
    catchError((error) => {
      return of(router.createUrlTree(['/auth', 'login']));
    }),
  );
};
